<app-navbar></app-navbar>

<!-- Content -->
<div class="container-fluid" id="top">
    <div class="row py-lg-5">
        <div class="col-sm-6 offset-sm-3 project-content">
            <mdb-card>
                <!-- Project's informations -->

                <!-- Project Title -->
                <h2>SITE E-COMMERCE en Html,Css,Mysql,Php </h2>
                <!-- Project date + duration -->
                <h4><b>Fin :</b> Janvier 2021</h4>
                <h4><b>Durée :</b> 5 mois</h4>

                <!-- Project image -->

                <!-- About the project -->
                <mdb-card-body>
                    <!-- Technologies used -->
                    <div class="row technos">
                        <div class="col-sm-6">
                            <div class="row">
                                <h4><b>Technologies : </b></h4>
                                <img class="dot" src="assets/skills/html.png" />
                                <img class="dot" src="assets/skills/css.png" />
                                <img class="dot" src="assets/skills/mysql.png" />
                                <img class="dot" src="assets/skills/php.png" />
                                <img class="dot" src="assets/skills/github.png" />
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="row">
                                <h4><b>Tags : </b></h4>
                                <p> Html,Css,Mysql,Php,github</p>
                            </div>
                        </div>
                    </div>
                    <div class="row description">
                        <!-- Description of the project -->
                        <div class="col-sm-6">
                            <h4><b>Description :</b></h4>
                            <p>

                            </p>
                        </div>


                        <div class="col-sm-6">
                            <h4><b>Contexte :</b></h4>
                            <p>
                                ALL4SPORT a été créé en 2008 à partir d’une idée toute simple: répondre aux besoins des sportifs amateurs et passionnés en leur proposant une gamme d’articles de sports adaptés à chacun d’eux. C'est une société anonyme au capital de 150 K€, elle réalise
                                un chiffre d’affaires annuel d’1,2 M€ et compte plus de 200 collaborateurs. Son siège sociale est basé à Lille, carrefour de l’Europe et grande ville étudiante et aux citoyens dynamiques. Organisé autour de 2 activités
                                principales : Logistique : stockage et transport. Vente : magasin et service en ligne.
                            </p>
                        </div>


                        <!-- Apports du projet -->
                        <div class="col-sm-6">
                            <h4><b>Bilan :</b></h4>

                            Lien de mon projet sur Github :
                            <li><a href="https://github.com/hugo59400/PPE3">Cliquer ici </a></li>



                        </div>
                    </div>
                </mdb-card-body>
            </mdb-card>
            <img src="assets/co.png" width="900" height="300" />
            <img src="assets/client.png" />
            <img src="assets/page.png" />
        </div>
    </div>
</div>

<app-projects></app-projects>